import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { numberFormat } from "../../../config/numberFormat";

const COLORS = ["#f97316", "#8b5cf6", "#facc15", "#10b981"];

export default function OtherIncomeChart({ data }) {
  const chartData = data.map((item) => {
    const total = item.chartData.reduce((acc, m) => acc + m.total, 0);
    return { name: item.category, value: total };
  });

  const totalAmount = chartData.reduce((sum, val) => sum + val.value, 0);

  if (totalAmount === 0) {
    return (
      <div style={styles.card}>
        <h3 style={styles.header}>Other Income</h3>
        <p style={{ color: "#999", fontStyle: "italic" }}>No data available</p>
      </div>
    );
  }
  return (
    <div style={styles.card}>
      <h3 style={styles.header}>
        Other Income - <span style={{ color: "#10b981" }}>+{numberFormat(totalAmount)}</span>
      </h3>

      <div style={styles.contentWrapper}>
        {/* Pie Chart */}
        <div style={styles.chartContainer}>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={2}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip formatter={(val) => `₹${numberFormat(val)}`} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Legend Table */}
        <div style={styles.legendTable}>
          <div style={styles.tableHeader}>
            <div style={styles.tableHeaderCell}>Category</div>
            <div style={styles.tableHeaderCellRight}>Amount</div>
          </div>
          {chartData.map((entry, index) => (
            <div key={entry.name} style={styles.tableRow}>
              <div style={styles.tableCellName}>
                <div
                  style={{
                    ...styles.legendColor,
                    backgroundColor: COLORS[index % COLORS.length]
                  }}
                ></div>
                <span style={styles.categoryText}>{entry.name}</span>
              </div>
              <div style={styles.tableCellValue}>
                <span style={{ color: "#10b981" }}>+{numberFormat(entry.value)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    fontFamily: "sans-serif",
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  header: {
    fontSize: "18px",
    marginBottom: "16px",
    fontWeight: "600"
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flex: 1
  },
  chartContainer: {
    width: "100%",
    height: "250px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  legendTable: {
    width: "100%",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    overflow: "hidden"
  },
  tableHeader: {
    display: "flex",
    backgroundColor: "#f9fafb",
    borderBottom: "2px solid #e5e7eb",
    padding: "10px 12px",
    fontWeight: "600",
    fontSize: "13px",
    color: "#374151"
  },
  tableHeaderCell: {
    flex: "1 1 60%",
    textAlign: "left"
  },
  tableHeaderCellRight: {
    flex: "1 1 40%",
    textAlign: "right"
  },
  tableRow: {
    display: "flex",
    padding: "10px 12px",
    borderBottom: "1px solid #f3f4f6",
    alignItems: "center",
    transition: "background-color 0.2s"
  },
  tableCellName: {
    flex: "1 1 60%",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0
  },
  categoryText: {
    fontSize: "14px",
    color: "#444",
    textTransform: "capitalize",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  tableCellValue: {
    flex: "1 1 40%",
    textAlign: "right",
    fontWeight: "600",
    fontSize: "14px",
    whiteSpace: "nowrap"
  },
  legendColor: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    flexShrink: 0
  }
};